import { dispatch } from '@src/dispatcher';
import CommonStore from '@src/stores/CommonStore';
import { searchForEntities } from '@src/actions/EntityActions';
import ACTION_TYPES from './actionTypes';
import * as Api from './api';

export function createDynamicNode(data) {
  return Api.createDynamicNode(data).then((response) => {
    const { body } = response;
    dispatch(ACTION_TYPES.SAVE_DYNAMICNODE_DATA, body);
    return new Promise((resolve) => resolve(body));
  });
}

export function saveDynamicNodeData(data) {
  return Api.saveDynamicNodeData(data.id, data).then((response) => {
    const { body } = response;
    dispatch(ACTION_TYPES.SAVE_DYNAMICNODE_DATA, body);
    return new Promise((resolve) => resolve(response));
  });
}

export function fetchDynamicNodeData(nodeId) {
  return Api.fetchDynamicNodeData(nodeId).then((response) => {
    const { body } = response;
    const currentLanguage = CommonStore.getCurrentLanguage();
    dispatch(ACTION_TYPES.RECEIVED_DYNAMICNODE_DATA, {
      ...body,
      ...currentLanguage,
    });
    return new Promise((resolve) => resolve(body));
  });
}

/**
 * This function is used to fetch the list of entities which are active on the bot.
 */
export function fetchEntitiesList(botName) {
  return searchForEntities({
    bot_name: botName,
    search_type: 'bot',
    action: 'entity_flusher',
    callback: (value) => {
      dispatch(ACTION_TYPES.RECEIVED_ENTITIES_LIST, value);
    },
  });
}

export function updateDynamicNodeData(
  key,
  value,
  currentLanguage,
  currentHybridLanguage
) {
  dispatch(ACTION_TYPES.UPDATE_DYNAMICNODE_DATA, {
    key,
    value,
    currentLanguage,
    currentHybridLanguage,
  });
}

export function setDynamicNodeCoords(x, y, cb = () => {}) {
  const updatedStore = { posX: x, posY: y };
  dispatch(ACTION_TYPES.SET_DYNAMICNODE_COORDS, updatedStore);

  cb();
}

export function resetDynamicNodeData(cb = () => {}) {
  dispatch(ACTION_TYPES.RESET_DYNAMICNODE_DATA);
  cb();
}

export function toggleDynamicNode(id, toggle, cb = () => {}) {
  const data = {};
  data.active = toggle;

  return new Promise(async (resolve, reject) => {
    try {
      const dynamicNodeResponse = await Api.saveDynamicNodeData(id, data);
      resolve(dynamicNodeResponse);
      cb();
    } catch (e) {
      cb('Error! There was a problem in completing your request');
      reject(e);
    }
  });
}

export function updateCurrentBotSaysLanguage(
  currentBotSaysLanguage,
  currentHybridLanguage
) {
  dispatch(ACTION_TYPES.SET_CURRENT_BOTSAYS_LANGUAGE, {
    currentBotSaysLanguage,
    currentHybridLanguage,
  });
}

export function setCurrentChannelId(channelId) {
  dispatch(ACTION_TYPES.SET_CURRENT_CHANNEL_ID, {
    channelId,
  });
}

export function updateBotResponsesByChannel(data, callback) {
  dispatch(ACTION_TYPES.UPDATE_BOT_RESPONSES_BY_CHANNEL, {
    data,
    callback,
  });
}
